import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCompactDisc, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Slider from '../../../common/Slider/Slider';
import Button from '../../../common/button/Button';

const LastPlayedSongsSlider = ({ songs, showSpotModal }) => {
    const reversedSongs = songs.slice().reverse();
    // every slide is 170 pixels wide (the first is an exception)
    const breakpoints = {
        320: {
            slidesPerView: 1,
        },
        520: {
            slidesPerView: 3,
        },
        690: {
            slidesPerView: 3,
        },
        860: {
            slidesPerView: 3,
        },
        1050: {
            slidesPerView: 4,
        },
        1220: {
            slidesPerView: 5,
        },
        1390: {
            slidesPerView: 5,
        },
        1560: {
            slidesPerView: 6,
        },
        1730: {
            slidesPerView: 6,
        },
    };
    // `now` stays null on the server/first render so the elapsed-time part is only added
    // once mounted on the client — avoids SSR/client markup mismatches from wall-clock time.
    const [now, setNow] = useState(null);

    useEffect(() => {
        setNow(Date.now());
        const intervalId = setInterval(() => setNow(Date.now()), 60000);

        return () => clearInterval(intervalId);
    }, []);

    const _getPlayedAtLabel = (item, isCurrentlyPlaying) => {
        const playedAt = new Date(item.time);
        const timeLabel = playedAt.toLocaleTimeString('pt-br', { hour: 'numeric', minute: 'numeric' });

        if (isCurrentlyPlaying) {
            return `${timeLabel} (agora)`;
        }

        if (!now) {
            return timeLabel;
        }

        const elapsedMinutes = Math.floor((now - playedAt.getTime()) / 60000);

        if (elapsedMinutes <= 0) {
            return `${timeLabel} (agora)`;
        }

        return `${timeLabel} (-${elapsedMinutes}m)`;
    };

    const _mapSongs = () => reversedSongs.map((item, index) => {
        // @TODO make this a standalone component once we implement the complete history
        const artist = item.artist;
        const song = item.song;
        const songSlug = item.slug;
        const hasCover = !!item.cover;
        const imageSrc = hasCover ? item.cover.replace('1000x1000', '150x150') : 'https://a1media.antena1.com.br/image/album/150x150/defaultAlbum.jpg';
        const isCommercial = item.metaType === 'commercial';
        const spotSlug = item.spotSlug;
        let imageAlt = hasCover ? `Album - ${artist} - ${song}` : `Antena 1 Default Album para ${artist}`;
        let commercialExtraClass = '';

        if (isCommercial) {
            imageAlt = hasCover ? `Imagem do spot de ${artist}` : `Antena 1 Default Imagem para ${artist}`;

            // Check if and which border must be rounded
            const prevItem = index > 0 && reversedSongs[index - 1];
            const nextItem = index < reversedSongs.length - 1 && reversedSongs[index + 1];

            if (!prevItem || prevItem.metaType !== 'commercial') {
                commercialExtraClass += ' left';
            }

            if (!nextItem || nextItem.metaType !== 'commercial') {
                commercialExtraClass += ' right';
            }
        }

        return (
            <div key={item.time} className={`lastPlayedSongs-slider-wrapper${isCommercial ? ' commercial' : ''}${commercialExtraClass}`}>
                <div className="lastPlayedSongs-slider-block">
                    {
                        (songSlug || spotSlug) ?
                            songSlug ?
                                <Button className="lastPlayedSongs-slider-block-button" title="Saiba mais sobre essa música" to={`/musicas/${songSlug}`}>
                                    <img
                                        alt={imageAlt}
                                        aria-hidden
                                        className="lastPlayedSongs-slider-block-albumCover"
                                        src={imageSrc}
                                        loading="lazy"
                                    />
                                    {/*
                                    <div className="musicSlugOverlay">
                                        <FontAwesomeIcon icon={faCompactDisc} className="musicSlugOverlayIcon" width="100%" height="100%" />
                                    </div>
                                    */}
                                </Button> :
                                <Button className="lastPlayedSongs-slider-block-button" title="Saiba mais sobre esse anúncio" onClick={() => showSpotModal(spotSlug)}>
                                    <img
                                        alt={imageAlt}
                                        aria-hidden
                                        className="lastPlayedSongs-slider-block-albumCover"
                                        src={imageSrc}
                                        loading="lazy"
                                    />
                                    {/*
                                    <div className="musicSlugOverlay">
                                        <FontAwesomeIcon icon={faInfoCircle} className="musicSlugOverlayIcon" width="100%" height="100%" />
                                    </div>
                                    */}
                                </Button>
                            :
                            // eslint-disable-next-line react/jsx-indent
                            <img
                                alt={imageAlt}
                                aria-hidden
                                className="lastPlayedSongs-slider-block-albumCover"
                                src={imageSrc}
                                loading="lazy"
                            />
                    }
                    <div className="lastPlayedSongs-slider-block-info">
                        <p className="lastPlayedSongs-slider-block-time">
                            {_getPlayedAtLabel(item, index === 0)}
                        </p>

                        <p className="lastPlayedSongs-slider-block-info-artist">
                            {(song && song.length > 32) ? `${song.slice(0, 32)}...` : song}
                        </p>

                        <p className="lastPlayedSongs-slider-block-info-song">
                            {artist}
                        </p>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <div className="lastPlayedSongs-slider" tabIndex="-1">
            <Slider
                breakpoints={breakpoints}
                autoplay={false}
                loop={false}
                slideActiveClass="lastPlayedSongs-slider-block-active"
            >
                {_mapSongs()}
            </Slider>
        </div>
    );
};

LastPlayedSongsSlider.propTypes = exact({
    songs: PropTypes.arrayOf(
        PropTypes.shape({
            artist: PropTypes.string.isRequired,
            song: PropTypes.string.isRequired,
            time: PropTypes.string.isRequired,
            cover: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.bool,
            ]),
            slug: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.bool,
            ]),
        }),
    ).isRequired,
    showSpotModal: PropTypes.func.isRequired,
});

export default LastPlayedSongsSlider;
